import { useSyncExternalStore } from "react";
import {
  isPowerPointSkillsEnabled,
  subscribeFeatureFlags,
} from "../services/featureFlagService";

/**
 * React view of the atomic `skills && pptxSkills` add-in gate.
 */
export function usePowerPointSkillsEnabled(): boolean {
  return useSyncExternalStore(
    subscribeFeatureFlags,
    isPowerPointSkillsEnabled,
    () => false
  );
}
